import { yupResolver } from '@hookform/resolvers';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { Card, CardContent, MenuItem, TextField } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { CommonYupValidation } from 'helpers/yup';
import { SystemMsgs } from 'helpers/SystemMsg';
import { PhoneNumInput } from '@ifca-root/react-component/src/components/Input/PhoneNumInput';
import { AddressAutoCompleteComponent } from '@ifca-root/react-component/src/components/Address/AddressAutoCompleteComponent';
import { useAddressAutoComplete } from 'helpers/hooks/useAddressAutoComplete';
import { countryAlphaCodes } from 'utils/countryAlphaCodes';
import { countryCurrencyCodes } from 'utils/countryCurrencyCodes';
import {
  CreditCardType,
  GetAllOrderItemDocument,
	GetBillDocument,
	GetOrderItemDocument,
	OrderItemStatus,
	PaymentClass,
	useCreateOnlinePaymentMutation,
	useCreatePaymentByQuantityMutation,
	useGetAllOrderItemLazyQuery,
	useGetCountryNameLazyQuery,
	useGetDefaultPaymentQuery,
	useGetOutletNameQuery,
	useGetRoundingPolicyQuery,
	useGetStateNameLazyQuery,
	useSubmitDocumentEInvoice3rdpartyMutation,
	useUpdateBuyerInformationMutation,
} from 'generated/graphql';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { useHistory, useLocation, useParams } from 'react-router';
import SnackBarContext from 'containers/App/Store/SnackBarContext';
import { DynamicFooter } from 'components/Footer/DynamicFooter';
import { amtNumStr } from 'helpers/numFormatter';
import { FooterAmount } from '../SharedFunction';

interface BillUserEInvoiceFormProps {
	name: string;
	email: string;
	contactNo: string;
	address: string;
	country: string;
	state: string;
	city: string;
	postcode: string;
	identityType: string;
	identityNumber: string;
	tin: string;
	regNo: string;
}
interface BuyerState {
  selectedDebtor?: any;
  data?: any; 
  stateItem?: any;
  selectedCredit?: any;
  cardType?: any;
  cardReference?: any;
  filesLHDN?: any;
  selectedRoom?: any;
  selectedNonGuest?: any;
  selectedFolio?: any;
  remark?: string;
  selectedOfficer?: any;
  selectedStaff?: any;
}
export const LHDNBuyerDetailsForm = props => {
  const { tableID, outletID, orderID } = useParams<Record<string, any>>();
	const location = useLocation<BuyerState>();
	const { data, setIsBuyerDetails, stateItem, selectedCredit,cardReference,remark} = props;
	const mode = 'edit';
	const debtordata = location?.state?.selectedDebtor 
  const creditdata = location?.state?.selectedCredit;
  const roomData = location?.state?.selectedRoom;
  const nonGuestData = location?.state?.selectedNonGuest;
  const officerData = location?.state?.selectedOfficer;
  const staffData = location?.state?.selectedStaff;
  const folioData = location?.state?.selectedFolio;
	const history = useHistory();
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const paymentData = location?.state?.data
  const itemData = location?.state?.stateItem;
  const typeCard = location?.state?.cardType;
  const files = location?.state?.filesLHDN;
  

	const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
		SnackBarContext as any,
	);

      const {
      loading: paymentLoading,
      data: { getDefaultPayment } = { getDefaultPayment: [] },
    } = useGetDefaultPaymentQuery({
      fetchPolicy: 'network-only',
      variables: { outletID: outletID, orderByAsc: 'paymentClass' },
    });
    
    	const selectedPaymentClass = () => {
		const name = getDefaultPayment?.filter(
			x => x?.ID === watch('defaultPaymentID'),
		)[0]?.paymentClass;
		return name;
	};

    const getSelectedOrderItemIDs = () => {
		let temp = itemData?.itemArray.filter(v => v?.quantity > 0);

		return temp?.map(x => {
			return {
				orderItemID: x?.ID,
				paymentQuantity: x?.quantity,
			};
		});
	};
      const [
      createOnlinePayment,
      { loading: createOnlinePaymentLoading },
    ] = useCreateOnlinePaymentMutation({
      onError: error => {
        console.log('ERROR', error);
      },
      onCompleted: ({ createOnlinePayment }) => {
        setLockedlhdn(false);

      },
    });

	const integrate3rdPartyeInvoice = data?.outlet?.integrate3rdPartyeInvoice;

	const [
		loadCountry,
		{
			loading: getCountryLoading,
			data: { getCountryName } = { getCountryName: [] },
		},
	] = useGetCountryNameLazyQuery({
		fetchPolicy: 'network-only',
	});

	const [
		loadState,
		{ loading: getStateLoading, data: { getStateName } = { getStateName: [] } },
	] = useGetStateNameLazyQuery({
		fetchPolicy: 'network-only',
	});


	const [
		submitDocumentEInvoice3rdparty,
		{
			loading: submitDocumentEInvoice3rdpartyLoading,
			called: submitDocumentEInvoice3rdpartyCalled,
			error: submitDocumentEInvoice3rdpartyError,
			data: submitDocumentEInvoice3rdpartyDate,
		},
	] = useSubmitDocumentEInvoice3rdpartyMutation({
		onError: error => {
			setOpenSnackBar(true);
			// If error has a message, display it
			setSnackBarMsg(error?.message || 'An unknown error occurred.');
		},
		onCompleted: data => {
			if (data?.submitDocumentEInvoice3rdparty?.status === 'error') {
				const errorDetails =
					data?.submitDocumentEInvoice3rdparty?.message ||
					'Unknown error message';

				// Parse the error details string to extract errorMessages
				try {
					const parsedError = JSON.parse(
						errorDetails.replace('HTTP error! Status: 400, Details: ', ''),
					);

					const errorMessages =
						parsedError?.schemaError?.[0]?.errorMessages ||
						'No specific errors';
					setOpenSnackBar(true);
					setSnackBarMsg(`Submission failed. Error: ${errorMessages}`);
				} catch (parseError) {
					setOpenSnackBar(true);
					setSnackBarMsg('Error parsing the error details.');
				}
			} else if (data?.submitDocumentEInvoice3rdparty?.status === 'success') {
				// For success response (e.g., if status is not 'error')
				setOpenSnackBar(true);
				setSnackBarMsg('Record submitted successfully!');
				setTimeout(() => {
					window.location.reload();
				}, 500);
			}
		},
	});

	const {
		getCountry,
		getStatebyCountry,
		getCitybyState,
		getPostcodebyCity,
		handleCountryOnChange,
		handleStateOnChange,
		handleCityOnChange,
		handlePostCodeOnChange,
		handleGoogleOnChange,
		query,
		autoCompleteRef,
		state,
		setQuery,
		dispatch,
		initializeEditValue,
	} = useAddressAutoComplete();

	const [country, setCountry] = useState('');
	const [newState, setState] = useState('');
	const [city, setCity] = useState('');
	const [newPostcode, setPostcode] = useState('');
	const [countryCode, setCountryCode] = useState('my');
	const [ogAddr, setOGAddr] = useState(null);
	const [addrValue, setAddress] = useState(null);
  const [selectedOfficer, setSelectedOfficer] = useState({} as any);
  const [selectedStaff, setSelectedStaff] = useState({} as any);
  const [selectedNonGuest, setSelectedNonGuest] = useState({} as any);
  const [defaultOfficer, setDefaultOfficer] = useState({} as any);
  const [selectedRoom, setSelectedRoom] = useState({} as any);
  const [defaultFolio, setDefaultFolio] = useState({} as any);
  const [defaultNonGuest, setDefaultNonGuest] = useState({} as any);
  const [selectedFolio, setSelectedFolio] = useState({} as any);
  const [selectedDebtor, setSelectedDebtor] = useState({} as any);
  const [defaultStaff, setDefaultStaff] = useState({} as any);
  const [defaultRoom, setDefaultRoom] = useState({} as any);
  const [defaultDebtor, setDefaultDebtor] = useState({} as any);
  const [hotelGuestInfo, setHotelGuestInfo] = useState({} as any);
  const [lockedlhdn, setLockedlhdn] = useState(false);
      const creditCardEnum = data => {
        let credClass;
        if (data === 'American Express Card') {
          credClass = CreditCardType.AmericanExpressCard;
        } else if (data === 'Diners Card') {
          credClass = CreditCardType.DinersCard;
        } else if (data === 'JCB Card') {
          credClass = CreditCardType.JcbCard;
        } else if (data === 'Master Card') {
          credClass = CreditCardType.Mastercard;
        } else if (data === 'UNION PAY') {
          credClass = CreditCardType.UnionpayCard;
        } else if (data === 'Visa Card') {
          credClass = CreditCardType.VisaCard;
        } else if (data === 'Debit Card') {
          credClass = CreditCardType.DebitCard;
        } else if (data === 'E-Wallet') {
          credClass = CreditCardType.Ewallet;
        }
        return credClass;
      };

    let paymentInputArr = [];

	useEffect(() => {
		if (getCountry?.length > 0 && mode === 'edit') {
			let currCountry = getCountry?.find(v => {
				return (
					v?.name?.toLowerCase() === debtordata?.Country?.toLowerCase() ||
          v?.name?.toLowerCase() === creditdata?.Country?.toLowerCase()
				);
			});

			handleCountryOnChange(currCountry);
		}
	}, [getCountry, mode]);


  useEffect(() => {
      if (roomData?.CreditBalance !== undefined) {
        setHotelGuestInfo(roomData);
      } else if (nonGuestData?.CreditBalance !== undefined) {
        setHotelGuestInfo(nonGuestData);
      } else if (debtordata?.CreditBalance !== undefined) {
        setHotelGuestInfo(debtordata);
      } else if (folioData?.CreditBalance !== undefined) {
        setHotelGuestInfo(folioData);
      } else if (roomData?.CreditBalance !== undefined) {
        setHotelGuestInfo(roomData);
      } else if (defaultNonGuest?.CreditBalance !== undefined) {
        setHotelGuestInfo(defaultNonGuest);
      } else if (debtordata?.CreditBalance !== undefined) {
        setHotelGuestInfo(debtordata);
      } else if (defaultFolio?.CreditBalance !== undefined) {
        setHotelGuestInfo(defaultFolio);
      } else if (typeCard?.CreditBalance !== undefined) {
        setHotelGuestInfo(typeCard);
      }
    }, [
      roomData,
      defaultRoom,
      nonGuestData,
      defaultNonGuest,
      debtordata,
      selectedDebtor,
      defaultFolio,
      folioData,
      typeCard,
    ]);

	useEffect(() => {
		const regex = new RegExp(`\\b(${country})\\b`, 'g');
		const countryCodes = Object.keys(countryAlphaCodes);
		if (country !== '') {
			countryCodes.forEach(code => {
				if (regex.test(countryAlphaCodes?.[code])) {
					setCountryCode(code.toLowerCase() ?? 'my');
				}
			});
			let alphaCode;
			const currencyCodes = Object.keys(countryCurrencyCodes);
			currencyCodes.forEach(code => {
				if (regex.test(countryCurrencyCodes?.[code])) {
					alphaCode = code;
				}
			});
		}
	}, [country]);

	useEffect(() => {
		if (mode === 'edit' && (debtordata || creditdata)) {
			let array_of_address = [
				creditdata?.Address || debtordata?.Address,
				creditdata?.City || debtordata?.City,
				getStateName[0]?.name || creditdata?.State || debtordata?.State,
				getCountryName[0]?.name || creditdata?.Country || debtordata?.Country,
			];
			setQuery(array_of_address.join(', '));
			setOGAddr(array_of_address.join(', '));
			setAddress(array_of_address?.slice(0));
			initializeEditValue({
				address: creditdata?.Address || debtordata?.Address,
				country: getCountryName[0]?.name || creditdata?.Country || debtordata?.Country,
				state: getStateName[0]?.name || creditdata?.State || debtordata?.State,
				city:  creditdata?.City || debtordata?.City,
				postCode: creditdata?.postCode || debtordata?.postCode,
			});
		}
	}, [mode,creditdata, debtordata, getCountryName[0]?.name, getStateName[0]?.name]);

	const billUserEInvoiceSchema = yup.object().shape({
		name: CommonYupValidation.requireField(SystemMsgs.name()),
		email: yup
			.string()
			.required('Email is required.')
			.trim()
			.test(
				'not-na',
				'"NA" is not allowed.',
				value => value?.toLowerCase() !== 'na',
			)
			.email('Invalid email format.'),
		contactNo: CommonYupValidation.requireField(SystemMsgs.contactNo()),
		regNo: CommonYupValidation.requireField('Registration Number is required'),
		identityNumber: CommonYupValidation.requireField(
			'Identity Number is required',
		),
		identityType: CommonYupValidation.requireField('Identity Type is required'),
		tin: CommonYupValidation.requireField('TIN is required'),
	});

	const {
		handleSubmit,
		register,
		errors,
		control,
		getValues,
		watch,
		formState: { isSubmitting, isSubmitted, dirtyFields, isDirty },
	} = useForm<BillUserEInvoiceFormProps>({
		defaultValues: {
			address: '',
			country: '',
			state: '',
			city: '',
			postcode: '',
		},
		mode: 'onSubmit',
		resolver: yupResolver(billUserEInvoiceSchema),
	});


	useEffect(() => {
		if ( creditdata?.Country || debtordata?.Country) {
			loadCountry({
				variables: {
					eInvCode: creditdata?.Country || debtordata?.Country,
				},
			});
		}
	}, [creditdata?.Country, debtordata?.Country]);
	useEffect(() => {
		if (getCountryName[0]?.ID) {
			loadState({
				variables: {
					countryID: getCountryName[0]?.ID,
					eInvCode: creditdata?.State || debtordata?.State,
				},
			});
		}
	}, [getCountryName[0]?.ID]);

      const {
      loading: outletLoading,
      data: { getOutlet } = { getOutlet: [] },
    } = useGetOutletNameQuery({
      fetchPolicy: 'network-only',
      variables: { ID: outletID }
    });


        const [
          createPaymentByQuantity,
          { loading: paymentQuantityLoading },
        ] = useCreatePaymentByQuantityMutation({
          onError: error => {
            console.log('ERROR', error?.message);
            setOpenSnackBar(true);
            setSnackBarMsg(error.message);
          },
          onCompleted: ({ paymentByQuantity }) => {
            history.push(
              `/menu/outlet-app/${outletID}/table/grid/${tableID}/order/${itemData?.orderID}/bill-settlement/${paymentByQuantity?.ID}`,
            );
            dispatch({ type: 'radioError', payload: false });
            setOpenSnackBar(true);
            setSnackBarMsg(SystemMsgs.createNewRecord());
          },
        });
    
        let paymentUrl;

      const [
      LoadOrderItem,
      {
        loading: useGetAllOrderItemLoading,
        called: useGetAllOrderItemCalled,
        data: { getAllOrderItem } = { getAllOrderItem: [] },
      },
    ] = useGetAllOrderItemLazyQuery({
      fetchPolicy: 'network-only'
    });

      const {
        data: { getRoundingPolicy } = { getRoundingPolicy: [] },
        loading: getRoundingPolicyLoading,
      } = useGetRoundingPolicyQuery({
        fetchPolicy: 'network-only',
        variables: { accountID: user?.accountID },
      });

    const footerAmount = FooterAmount(
      getAllOrderItem,
      'payment',
      getRoundingPolicy,
    );


  const onSubmit = async () => {
     if (lockedlhdn) return;
      setLockedlhdn(true);
      const ref = itemData?.selectedOrder?.docNo;
      let billInput;
      let totalReceiveAmount = 0;
  
      console?.log(data, 'data1');
  
      const selectedPayments = paymentData
        ?.slice() // optional: create a shallow copy to avoid mutating the original
        ?.sort((a, b) => (a?.paymentSort ?? 0) - (b?.paymentSort ?? 0))
        ?.filter(x => x?.selected === true);
      const lastIndex = selectedPayments?.length - 1;


  
      selectedPayments
        ?.slice() // optional: create a shallow copy to avoid mutating the original
        ?.sort((a, b) => (a?.paymentSort ?? 0) - (b?.paymentSort ?? 0))
        ?.map((v, index) => {
          billInput = {
            orderID: itemData?.selectedOrder?.ID,
            outletID: outletID,
            ...(v?.paymentClass === PaymentClass.Room ||
                      v?.paymentClass === PaymentClass.Member ||
                      v?.paymentClass === PaymentClass.NonGuest ||
                      v?.paymentClass === PaymentClass.Debtor ||
                      v?.paymentClass === PaymentClass.SuspendFolio
                        ? { file: files }
                        : {}),
                        
                  einvoice_buyer_name:
                   watch('name') ?? debtordata?.DebtorName ?? creditdata?.DebtorName ??'',
                  einvoice_buyer_tin: watch('tin') ?? debtordata?.Tin ?? creditdata?.Tin ?? '',
                  einvoice_buyer_regno:
                   watch('identityNumber') ?? debtordata?.CompanyRegNo ?? creditdata?.CompanyRegNo ?? '',
                  einvoice_buyer_address:
                   state?.address ?? debtordata?.Address ?? creditdata?.Address ?? '',
                  einvoice_buyer_post_code:
                   state?.postcode?.postcode ?? debtordata?.postCode ?? creditdata?.postCode ?? '',
                  einvoice_buyer_city:
                  state?.city?.name ?? debtordata?.City ?? creditdata?.City ?? '',
                  einvoice_buyer_state:
                  state?.state?.name ?? debtordata?.State ?? creditdata?.State ?? '',
                  einvoice_buyer_country:
                  state?.country?.name ?? debtordata?.Country ?? creditdata?.Country ?? '',
                  einvoice_buyer_contact_no:
                    watch('contactNo') ?? debtordata?.ContactNo ?? creditdata?.ContactNo ?? '',
                  einvoice_buyer_identity_type:
                    watch('identityType') ?? debtordata?.InvoiceType ?? creditdata?.InvoiceType,
                  einvoice_buyer_email:
                    watch('email') ?? debtordata?.Email ?? creditdata?.Email ?? '',
                  einvoice_directsend: true,
                  einvoice_buyer_tax_regno: watch('regNo') ?? debtordata?.TaxRegNo ?? creditdata?.TaxRegNo ?? 'NA',
				};
  
          const creditAccount = typeCard?.RegistrationID
            ? typeCard
            : creditdata?.RegistrationID
            ? creditdata
            : selectedCredit?.RegistrationID
            ? selectedCredit
            : null;

          let paymentInput = {
            outletID: outletID,
            amount:
              v?.paymentClass === PaymentClass?.Cash
                ? itemData?.receivedAmount
                : (v?.amountPayment ?? 0) + (v?.rounding ?? 0),
            creditCardType:
              creditAccount?.GuestType !== null &&
              creditAccount?.GuestType !== undefined
                ? creditCardEnum(creditAccount?.GuestType)
                : creditAccount,
            cardNo: location?.state?.cardReference ?? cardReference,
            changeAmount:
              v?.paymentClass === PaymentClass?.Cash
                ? Math.abs(itemData.changeAmount) >= 0
                  ? Math.round(
                      (Math.abs(itemData.changeAmount ?? 0) + Number.EPSILON) * 100,
                    ) / 100
                  : Math.round(
                      (Math.abs(itemData.changeAmount ?? 0) + Number.EPSILON) * 100,
                    ) / 100
                : 0,
            receivedAmount:
              v?.paymentClass === PaymentClass?.Cash
                ? itemData?.receivedAmount !== 0
                  ? itemData?.receivedAmount ?? 0
                  : (v?.amountPayment ?? 0) + (v?.rounding ?? 0)
                : (v?.amountPayment ?? 0) + (v?.rounding ?? 0),
            roundingAmount: index === lastIndex ? v?.rounding ?? 0 : 0,
            // saveRounding(data?.defaultPayment, v, index, lastIndex) ?? 0,
            defaultPaymentID: v?.defaultPaymentID,
            paymentClass: v?.paymentClass,
            patronAccountID:
              officerData?.ID !== null ||
              officerData?.ID !== undefined ||
              staffData?.ID !== null ||
              staffData?.ID !== undefined
                ? officerData?.ID ?? staffData?.ID
                : null,
            registrationID:
              v?.paymentClass === PaymentClass?.Room
                ? roomData?.RegistrationID 
                : v?.paymentClass === PaymentClass?.NonGuest
                ? nonGuestData?.RegistrationID 
                // ??defaultNonGuest?.RegistrationID
                : v?.paymentClass === PaymentClass?.SuspendFolio
                ? folioData?.RegistrationID ?? defaultFolio?.RegistrationID
                : v?.paymentClass === PaymentClass?.Debtor
                ? debtordata.RegistrationID 
                : v?.paymentClass === PaymentClass?.Credit
                ? creditAccount?.RegistrationID : null,

  
            hotelGuestInfo: {
              BookingNo: hotelGuestInfo?.BookingNo,
              FullName: hotelGuestInfo?.GuestName,
              RoomNo: hotelGuestInfo?.RoomNo,
              GuestType: hotelGuestInfo?.GuestType,
              ArrivalDate: hotelGuestInfo?.ArrivalDate,
              DepartureDate: hotelGuestInfo?.DepartureDate,
              DebtorAccount: hotelGuestInfo?.DebtorAccount,
              CompanyName: hotelGuestInfo?.CompanyName,
            },
            referenceNo: v?.referenceNo,
            remark: v.remark,
            billLedgerInput: {
              HotelID: getOutlet[0]?.outletChannel?.hotelID,
              RegistrationID:
                roomData?.RegistrationID ??
                nonGuestData?.RegistrationID ??
                folioData?.RegistrationID,
                // defaultRoom?.RegistrationID ??
                // defaultNonGuest?.RegistrationID,
                // defaultFolio?.RegistrationID,
              OutletCode: getOutlet[0]?.outletCode,
              IncidentalChargeID: '',
              Reason:
                v?.paymentClass === PaymentClass?.Room
                  ? 'MenuX - Charge To Room'
                  : v?.paymentClass === PaymentClass?.NonGuest
                  ? 'MenuX - Charge To Non Guest'
                  : v?.paymentClass === PaymentClass?.SuspendFolio
                  ? 'MenuX - Charge To Suspend Folio'
                  : v?.paymentClass === PaymentClass?.Debtor
                  ? 'MenuX - Charge To Debtor'
                  : v?.paymentClass === PaymentClass?.Credit
                  ? 'MenuX - Charge To Credit'
                  : '',
              Description: `${getOutlet[0]?.outletCode} -  ${ref}`,
              TrxDate: new Date(),
              Qty: 1,
              UnitPrice: parseFloat(
                amtNumStr((v?.amountPayment ?? 0) + (v?.rounding ?? 0)),
              ),
              TrxAmount: parseFloat(
                amtNumStr((v?.amountPayment ?? 0) + (v?.rounding ?? 0)),
              ),
              BaseAmount: parseFloat(
                amtNumStr((v?.amountPayment ?? 0) + (v?.rounding ?? 0)),
              ),
              ServiceCharge: parseFloat(amtNumStr(0)),
              TaxAmount: parseFloat(amtNumStr(0)),
              DiscountAmount: 0,
              IsChargeToRoom: true,
              ReferenceNo: ref,
              CreatedBy: user?.ID,
            },
            scheduleBillingInput: {
              HotelID: getOutlet[0]?.outletChannel?.hotelID,
              BillNo: ref,
              CardNo: v?.cardRef,
              BillDate: new Date(),
              BillAmount: (v?.amountPayment ?? 0) + (v?.rounding ?? 0),
              DebtorID:
                v?.paymentClass === PaymentClass?.Credit
                  ? creditAccount?.RegistrationID
                  : debtordata?.RegistrationID,
              CreatedBy: user?.ID,
            },
          };
          paymentInputArr?.push(paymentInput);
        });

        console.log(paymentInputArr, 'paymentInputArr');
  
      paymentInputArr?.map(x => {
        totalReceiveAmount += Number(
          x?.paymentClass === PaymentClass.Cash ? x?.receivedAmount : x?.amount,
        );
      });
  
      dispatch({ type: 'lastArray', payload: paymentInputArr });
  
  
      if (
        selectedPaymentClass() === PaymentClass.Online &&
        lockedlhdn === false 
      ) {
        createOnlinePayment({
          variables: {
            redirectUrl: `${paymentUrl}/menu/outlet-app/bill-settlement/online-payment/redirect`,
            payAmount: footerAmount?.total,
            detail: 'Detail',
            title: `Online Payment`,
            outletID: outletID,
          },
        }).then(i => {
          if (i?.data?.createOnlinePayment?.code === 'SUCCESS') {
            localStorage.setItem(
              'checkoutId',
              i?.data?.createOnlinePayment?.item?.checkoutId,
            );
            localStorage.setItem(
              'paymentInfo',
              JSON.stringify({
                paymentByQuantityInput: getSelectedOrderItemIDs(),
                billInput: billInput,
                paymentInput: paymentInputArr,
                tableID: tableID,
              }),
            );
            window.location.assign(i?.data?.createOnlinePayment?.item?.url);
            setOpenSnackBar(true);
            setSnackBarMsg(SystemMsgs.gatewayRedirect());
          } else {
            i?.data?.createOnlinePayment?.error?.code !== ''
              ? setSnackBarMsg(i.data.createOnlinePayment?.error.message)
              : setSnackBarMsg(SystemMsgs.paymentFailed());
            setOpenSnackBar(true);
          }
        });
      } else  {
        createPaymentByQuantity({
          variables: {
            paymentByQuantityInput: getSelectedOrderItemIDs(),
            billInput,
            paymentInput: paymentInputArr,
          },
          refetchQueries: [
            {
              query: GetOrderItemDocument,
              variables: {
                orderID: itemData?.selectedOrder?.ID,
                status: OrderItemStatus.Confirmed,
              },
            },
            {
              query: GetAllOrderItemDocument,
              variables: { orderID: itemData?.selectedOrder?.ID },
            },
          ],
        });
      };
    };

	const identityTypeData = [
		{
			name: 'Identity Card (NRIC)',
			code: data?.outlet?.integrate3rdPartyeInvoice === true ? 'NRIC' : 'NRIC',
		},
		{
			name: 'Passport',
			code:
				data?.outlet?.integrate3rdPartyeInvoice === true
					? 'PASSPORT'
					: 'ForeignBuyer',
		},
		{
			name: 'Business Registration Number',
			code:
				data?.outlet?.integrate3rdPartyeInvoice === true ? 'BRN' : 'Company',
		},
		{ name: 'Military Card', code: 'ARMY' },
	];

	return (
		<>
			{getStateLoading && <Loading />}
			{getCountryLoading && <Loading />}

      <CardContents
        style={{
          overflowY: 'auto',
          maxHeight: 'calc(100vh - 120px)',
          paddingRight: '10px',
        }}
      >
        <Card
          style={{
            backgroundColor: '#f0f0f0',
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
            width: '100%',
            marginTop: '1%',
            marginBottom: '4%',
          }}
        >
          <CardContent>
            <div
              style={{
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '14px',
                fontStyle: 'italic',
                marginTop: '5px',
              }}
            >
              Please complete the following form :
            </div>

            <Controller
              as={TextField}
              name="name"
              fullWidth
              margin="normal"
              label="Name"
              required
              defaultValue={watch('name') || debtordata?.DebtorName || creditdata?.DebtorName || ''}
              helperText={errors?.name?.message}
              error={errors?.name ? true : false}
              control={control}
              ref={register}
              autoComplete="nope"
            ></Controller>

            <Controller
              as={TextField}
              name="email"
              label="Email Address"
              autoComplete="off"
              multiline={true}
              required
              defaultValue={watch('email') || debtordata?.Email || creditdata?.Email || ''}
              fullWidth
              ref={register}
              control={control}
              margin="dense"
              helperText={errors?.email?.message}
              error={errors?.email ? true : false}
            ></Controller>

            <Controller
              as={
                <PhoneNumInput
                  country={'my'}
                  specialLabel="Contact No."
                  fullWidth
                />
              }
              name="contactNo"
              type="tel"
              marginTop
              marginBottom
              required
              defaultValue={watch('contactNo') || debtordata?.ContactNo || creditdata?.ContactNo || ''}
              margin="normal"
              control={control}
              ref={register}
              helperText={errors?.contactNo?.message}
              error={errors?.contactNo ? true : false}
              autoComplete="off"
            ></Controller>

            <AddressAutoCompleteComponent
              getCountry={getCountry}
              getStatebyCountry={getStatebyCountry}
              getCitybyState={getCitybyState}
              getPostcodebyCity={getPostcodebyCity}
              handleCountryOnChange={handleCountryOnChange}
              handleStateOnChange={handleStateOnChange}
              handleCityOnChange={handleCityOnChange}
              handlePostCodeOnChange={handlePostCodeOnChange}
              handleGoogleOnChange={handleGoogleOnChange}
              autoCompleteRef={autoCompleteRef}
              state={state}
              country={country}
              setCountry={setCountry}
              setState={setState}
              setCity={setCity}
              newState={newState}
              newPostcode={newPostcode}
              setPostcode={setPostcode}
              city={city}
              formType={mode}
              isSubmitted={isSubmitted}
              creditdata={creditdata}
              debtordata={debtordata}
            />
            <Controller
              as={
                <TextField name="identityType">
                  {identityTypeData?.map(x => (
                    <MenuItem key={x.name} value={x.code}>
                      {x.name}
                    </MenuItem>
                  ))}
                </TextField>
              }
              name="identityType"
              margin="normal"
              label="Identity Type"
              fullWidth
              autoComplete="off"
              multiline={true}
              defaultValue={watch('identityType') || data?.einvoice_buyer_identity_type}
              select
              control={control}
              ref={register}
              required
              helperText={errors?.identityType?.message}
              error={errors?.identityType ? true : false}
            />
            <Controller
              as={TextField}
              name="identityNumber"
              label="Identity Number"
              autoComplete="off"
              multiline={true}
              required
              fullWidth
              ref={register}
              control={control}
              margin="dense"
              helperText={errors?.identityNumber?.message}
              defaultValue={ watch('identityNumber') ||
                creditdata?.CompanyRegNo || 
                debtordata?.CompanyRegNo || 
                ''
                // ? data.einvoice_buyer_regno.split(': ')[1]
                // : ''
              }
              error={errors?.identityNumber ? true : false}
              inputProps={{
                pattern: '[A-Za-z0-9]*', // Regex to allow only letters and digits
              }}
              // onInput={e => {
              //   // Optional: You can sanitize the input by removing non-alphanumeric characters
              //   e.target.value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
              // }}
            ></Controller>

            <Controller
              as={TextField}
              name="tin"
              label="Tax Identification Number (TIN)"
              autoComplete="off"
              multiline={true}
              required
              fullWidth
              ref={register}
              control={control}
              defaultValue={watch('tin') || debtordata?.Tin || creditdata?.Tin || ''}
              margin="dense"
              helperText={errors?.tin?.message}
              error={errors?.tin ? true : false}
            ></Controller>

            <Controller
              as={TextField}
              name="regNo"
              label="SST Registration Number"
              autoComplete="off"
              multiline={true}
              // required
              fullWidth
              defaultValue={watch('regNo') || debtordata?.TaxRegNo || creditdata?.TaxRegNo || 'NA'}
              ref={register}
              control={control}
              margin="dense"
              helperText={errors?.regNo?.message}
              error={errors?.regNo ? true : false}
            ></Controller>
          </CardContent>
        </Card>
      </CardContents>

			<DynamicFooter
				overlap
				options={[
					{
						name: 'Cancel',
						onClick: () => {
							// setIsBuyerDetails(false);
              history.push(`/menu/outlet-app/${outletID}/table/grid/${tableID}/order/${orderID}/payment`);
						},
						color: 'primary',
					},
					{
						name:
							integrate3rdPartyeInvoice === false ? 'Save' : 'Save & Submit',
						onClick: () => {
							  handleSubmit(onSubmit)();
						},
            disabled: lockedlhdn,
						color: lockedlhdn ? 'inherit' : 'primary',
					},
				]}
			/>
		</>
	);
};
